import * as React from 'react';
import { connectToItemCache } from '../../decorators/connectToItemCache';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { IActionProps, Action } from '../../action/Action';
import { withSelectedItems, withExactlyOneItem } from '../../decorators/selectors';
import { followItem as followItemDefault } from '../../../operations/followItem';
import { followedItemFacet, isFollowedFacet } from '../../../facets/ItemFacets';
import { enableFollowItemConfigurationFacet, configurationItemKey } from '../../../facets/ConfigurationFacets';
import { getItemActionEngagement } from '../../../models/telemetry/getItemEngagement';

export interface IFollowItemActionProps {
  itemKey: string;
}

export const ItemFollowAction: React.ComponentType<IFollowItemActionProps> = connectToItemCache((
  itemCache: IItemCache,
  props: IFollowItemActionProps
): IActionProps => {
  const {
    itemKey
  } = props;

  const { dispatch } = itemCache;
  const isFollowFileEnable = itemCache.demandItemFacet(enableFollowItemConfigurationFacet, configurationItemKey);

  if (!isFollowFileEnable) {
    return {
      isAvailable: false
    };
  }

  const followedItem = itemCache.demandItemFacet(followedItemFacet, itemKey);
  const followedItemKey = followedItem && followedItem.itemKey || '';
  const isFollowed = itemCache.demandItemFacet(isFollowedFacet, followedItemKey);
  const isFollowedResolved = itemCache.isItemFacetResolved(isFollowedFacet, followedItemKey);

  const onFollowItem = async () => {
    await dispatch(followItemDefault({
      items: {
        [followedItemKey]: { isFollowed: !isFollowed }
      }
    }));
  };

  const isAvailable = !!followedItem && isFollowedResolved;

  return {
    isAvailable: isAvailable,
    isToggled: !!isFollowed,
    onExecute: onFollowItem,
    ...getItemActionEngagement(itemCache, {
      itemKey,
      engagement: {
        name: 'Follow',
        isIntentional: true
      }
    })
  };
})(Action);

export const FollowAction: React.ComponentType<{}> = withSelectedItems()(withExactlyOneItem()(ItemFollowAction));
